"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  title: "Facility Evaluation",
  description: "We conduct a comprehensive audit of your clinical workflows and financial performance to identify untapped potential and operational gaps."
}, {
  id: 2,
  title: "Strategic Alignment",
  description: "Our team develops a customized management strategy that perfectly aligns surgeon needs with facility efficiency and compliance standards."
}, {
  id: 3,
  title: "Sustainable Growth",
  description: "We implement robust governance and advanced technology solutions to ensure long-term profitability and superior patient outcomes."
}];
function StepItem({
  step,
  index,
  "data-index": dataIndex
}: {
  step: typeof steps[0];
  index: number;
  "data-index": number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const isEven = index % 2 === 0;
  return <div data-section-id="154918" ref={ref} data-index={dataIndex} className={`relative flex w-full mb-16 last:mb-0 ${isEven ? "md:justify-start" : "md:justify-end"} transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      {}
      <div className="absolute left-8 md:left-1/2 top-0 w-12 h-12 bg-accent/20 text-accent-foreground rounded-full flex items-center justify-center font-sans font-bold text-xl shadow-sm -translate-x-1/2 z-10">
        {step.id}
      </div>

      {}
      <div className={`w-full md:w-1/2 pl-24 md:pl-0 pt-1.5 md:pt-0 ${isEven ? "md:pr-16 md:text-right" : "md:pl-16 md:text-left"}`}>
        <h3 className="text-2xl font-serif font-bold text-foreground mb-3">
          {step.title}
        </h3>
        <p className="text-base font-sans text-muted-foreground leading-relaxed">
          {step.description}
        </p>
      </div>
    </div>;
}
export default function HowTheServiceWorks() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}